import CRWDealListModule from "../../modules/crw-deal-list";

export function TestDealListModule() {
  // test passing in getAccessTokenOverride and ensure it accepts
  return <CRWDealListModule />;
}
export default TestDealListModule;
